import React from 'react'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    CardGridEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem3xs4,
    GridItem3xs6,
    GridItem6sm12xs12,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDivHeaderEntradaDadosCliente,
    NomeCliente,
    NascimentoCliente,
    IdadeCliente,
    SexoCliente,
    CepEnderecoCliente,
    NomeCurtoCliente,
    CpfCliente,
    RgCliente,
    IdClienteIntegracaoCRM,
    OrigemCliente,
    MomentoCliente,
    TipoCarteiraInvestimentoCliente,
    PossuiConjuge,
    TipoRegimeBens,
    Meacao,
    EstadoCivil,
    TipoIRCliente,
    //ObservacaoCliente,
    ContatoCliente,
    ContaInvestimentosCliente,
    ProfissaoCliente,
    ProfissaoClienteOutras,
    AvatarCliente,
} from '../cadastro-form/CadastroCompCliente'

import FormFormConjuge from './FormFormConjuge'



const FormFormCliente = ({ variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, vars, linhaFormList,
    jsonIntegracao }) => {

    return (
        <ValidatorFormPadrao
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer>
                <GridItem12>
                    <GridContainer>
                        <GridItem6sm12xs12>
                            <CardGridEntradaDados>
                                <CardGridDivHeaderEntradaDadosCliente
                                    variaveisGlobais={variaveisGlobais}
                                    values={values}
                                    handleChange={handleChange}
                                    handleSubmit={handleSubmit}
                                    setFieldValue={setFieldValue}
                                    vars={vars}
                                    linhaFormList={linhaFormList}
                                />

                                <CardGridDivBodyEntradaDados>
                                    <GridContainer>
                                        <NomeCliente
                                            values={values}
                                            handleChange={handleChange}
                                            jsonConfiguracao={vars.jsonConfiguracao}
                                        />
                                    </GridContainer>

                                    <GridContainer>
                                        <NascimentoCliente
                                            values={values}
                                            setFieldValue={setFieldValue}
                                        />
                                        <IdadeCliente
                                            values={values}
                                            handleChange={handleChange}
                                        />

                                        <GridItem3xs6>
                                            <SexoCliente
                                                values={values}
                                                handleChange={handleChange}
                                            />
                                        </GridItem3xs6>

                                        {linhaFormList.informaCep === "S" &&
                                        vars.linhaTipoLicenca.exibirSomentePrevidenciaPrivada === 'N' && 
                                        (!jsonIntegracao || !jsonIntegracao.integracaoInclusaoSiteInstitucional2) && (
                                            <CepEnderecoCliente
                                                variaveisGlobais={variaveisGlobais}
                                                values={values}
                                                handleChange={handleChange}
                                                handleSubmit={handleSubmit}
                                            />
                                        )}
                                    </GridContainer>

                                    {(linhaFormList.informaNomeCurto === "S" || linhaFormList.informaCpf === "S") && (
                                        <GridContainer>
                                            {linhaFormList.informaNomeCurto === "S" && 
                                            (!jsonIntegracao || !jsonIntegracao.integracaoInclusaoSiteInstitucional2) && (
                                                <NomeCurtoCliente
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            )}

                                            {linhaFormList.informaCpf === "S" && (
                                                <>
                                                    <CpfCliente
                                                        values={values}
                                                        handleChange={handleChange}
                                                        jsonConfiguracao={vars.jsonConfiguracao}
                                                    />

                                                    <IdClienteIntegracaoCRM
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />

                                                    <RgCliente
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                </>
                                            )}
                                        </GridContainer>
                                    )}

                                    {linhaFormList.informaConjuge === "S" && (
                                        <>
                                            <CardGridDividerElementos/>

                                            <GridContainer>
                                                <GridItem3xs4>
                                                    <PossuiConjuge
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                </GridItem3xs4>
                                                
                                                <TipoRegimeBens
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            </GridContainer>
                                            {linhaFormList.informaMeacao === "S" && 
                                            (!jsonIntegracao || !jsonIntegracao.integracaoInclusaoSiteInstitucional2) && (
                                                <Meacao
                                                    values={values}
                                                    handleChange={handleChange}
                                                /> 
                                            )}

                                            <GridContainer>
                                                <GridItem3xs4/>

                                                <TipoIRCliente
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                                
                                                <EstadoCivil
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            </GridContainer>
                                        </>
                                    )}

                                    {(linhaFormList.informaNomeCurto === "S" || linhaFormList.informaCpf === "S" ||
                                    linhaFormList.informaProfissao === "S") && (
                                        <CardGridDividerElementos/>
                                    )}

                                    {linhaFormList.informaProfissao === "S" && (
                                        <GridContainer>
                                            <ProfissaoCliente
                                                values={values}
                                                handleChange={handleChange}
                                            />

                                            <ProfissaoClienteOutras
                                                values={values}
                                                handleChange={handleChange}
                                            />
                                        </GridContainer>
                                    )}

                                    {(!jsonIntegracao || !jsonIntegracao.integracaoInclusaoSiteInstitucional2) && (
                                        <>
                                            {(linhaFormList.informaOrigemCliente === "S" ||
                                            values.tipoOrigemCliente ||
                                            linhaFormList.informaTipoCarteiraInvestimentoCliente === "S" ||
                                            linhaFormList.informaMomentoCliente === "S") && !values.jsonAcessoCliente.acessoCliente && (
                                                <CardGridDividerElementos/>
                                            )}

                                            {(linhaFormList.informaOrigemCliente === "S" || values.tipoOrigemCliente) &&
                                            !values.jsonAcessoCliente.acessoCliente && (
                                                <OrigemCliente
                                                    variaveisGlobais={variaveisGlobais}
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            )}
                                        
                                            {(linhaFormList.informaTipoCarteiraInvestimentoCliente === "S" ||
                                            linhaFormList.informaMomentoCliente === "S") && !values.jsonAcessoCliente.acessoCliente && (
                                                <GridContainer>
                                                    {linhaFormList.informaTipoCarteiraInvestimentoCliente === "S" && (
                                                        <TipoCarteiraInvestimentoCliente
                                                            variaveisGlobais={variaveisGlobais}
                                                            values={values}
                                                            handleChange={handleChange}
                                                            idConfiguracao={vars.idConfiguracao}
                                                        />
                                                    )}
                                                    {linhaFormList.informaMomentoCliente === "S" && (
                                                        <MomentoCliente
                                                            values={values}
                                                            handleChange={handleChange}
                                                        />
                                                    )}
                                                </GridContainer>
                                            )}

                                            {/*linhaFormList.informaObservacaoCliente === "S" && (
                                                <ObservacaoCliente
                                                    values={values}
                                                    handleChange={handleChange}
                                                />
                                            )*/}

                                            {linhaFormList.informaContatos === "S" && (
                                                <>
                                                    <CardGridDividerElementos/>

                                                    <ContatoCliente
                                                        values={values}
                                                        handleChange={handleChange}
                                                        jsonConfiguracao={vars.jsonConfiguracao}
                                                    />
                                                </>
                                            )}

                                            {linhaFormList.informaContasInvestimentos === "S" &&
                                            vars.linhaTipoLicenca.exibirSomentePrevidenciaPrivada === 'N' && (
                                                <>
                                                    <CardGridDividerElementos/>

                                                    <ContaInvestimentosCliente
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                </>
                                            )}
                                        </>
                                    )}

                                    <CardGridDividerElementos/>

                                    <AvatarCliente
                                        values={values}
                                        setFieldValue={setFieldValue}
                                    />                                          
                                </CardGridDivBodyEntradaDados>
                            </CardGridEntradaDados>
                        </GridItem6sm12xs12>

                        {values.possuiConjuge && (
                            <GridItem6sm12xs12>
                                <FormFormConjuge
                                    values={values}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    linhaTipoLicenca={vars.linhaTipoLicenca}
                                    linhaFormList={linhaFormList}
                                    jsonIntegracao={jsonIntegracao}
                                />
                            </GridItem6sm12xs12>
                        )}
                    </GridContainer>
                </GridItem12>
            </GridContainer>
        </ValidatorFormPadrao>
    )
}

export default FormFormCliente